import type {FC} from 'react';
import clsx from 'clsx';

interface Props {
	isOpen: boolean;
}

export const Hamburger: FC<Props> = ({isOpen}) => {
	return (
		<div aria-hidden="true">
			<div
				className={clsx(
					'h-0.5 w-6 bg-neutral-100 transition-transform',
					isOpen ? 'translate-x-0 translate-y-2 rotate-45' : '',
				)}
			/>
			<div
				className={clsx(
					'my-1.5 h-0.5 w-6 bg-neutral-100 transition-transform',
					isOpen ? 'scale-0 opacity-0' : '',
				)}
			/>
			<div
				className={clsx(
					'h-0.5 w-6 bg-neutral-100 transition-transform',
					isOpen ? 'translate-x-0 -translate-y-2 -rotate-45' : '',
				)}
			/>
		</div>
	);
};
